module.exports = __webpack_public_path__ + "static/CV_Seo Eun Kim-7bccc55ecebea809c45ccb373ad7e014.pdf";